import { render } from "./record_new2.vue?vue&type=template&id=8039f240&scoped=true"
import script from "./record_new2.vue?vue&type=script&lang=js"
export * from "./record_new2.vue?vue&type=script&lang=js"

import "./record_new2.vue?vue&type=style&index=0&id=8039f240&lang=scss&scoped=scoped"
import "./record_new2.vue?vue&type=style&index=1&id=8039f240&lang=css"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8039f240"]])

export default __exports__